import axios from 'axios';
import { getToken } from '../auth/setAuthToken';
class axiosService {
    getCookiesHeader() {
        const token = getToken();
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            delete axios.defaults.headers.common['Authorization'];
        }
    }
    // getResponType(){}
    getExportExcel(url, params) {
        this.getCookiesHeader();
        return axios({
            url: url, //your url
            method: 'GET',
            responseType: 'blob',
            params // important
        });
    }
    get(url, params) {
        this.getCookiesHeader();
        return axios.get(url, params);
    }
    getImage(url, body) {
        this.getCookiesHeader();
        return axios.get(url, body);
    }

    post(url, body) {
        this.getCookiesHeader();
        return axios.post(url, body);
    }
    put(url, body) {
        this.getCookiesHeader();
        return axios.put(url, body);
    }
    delete(url, body) {
        this.getCookiesHeader();
        return axios.delete(url, body);
    }
}
export default new axiosService();
